import { useEffect } from 'react';

/* Lightweight analytics loader. Reads env vars at build time and
 * conditionally injects the matching script tag once on mount.
 *
 *   REACT_APP_PLAUSIBLE_DOMAIN — your Plausible domain (e.g.
 *     "heavensentpromos.com"). When set, loads the Plausible
 *     script (~1KB, no cookies, GDPR/CCPA-friendly).
 *
 *   REACT_APP_GA_ID — a GA4 Measurement ID (e.g. "G-XXXXXXX").
 *     When set, loads the Google Analytics gtag script. Note:
 *     GA4 sets cookies, so you'll want a cookie banner before
 *     enabling this in production.
 *
 * If neither is set, this component is a no-op. That keeps dev
 * builds clean and lets you flip analytics on at deploy time
 * without code changes.
 */
function Analytics() {
  useEffect(() => {
    const plausibleDomain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    const gaId = process.env.REACT_APP_GA_ID;

    if (plausibleDomain && !document.querySelector('script[data-plausible]')) {
      const s = document.createElement('script');
      s.defer = true;
      s.src = 'https://plausible.io/js/script.js';
      s.setAttribute('data-domain', plausibleDomain);
      s.setAttribute('data-plausible', 'true');
      document.head.appendChild(s);
    }

    if (gaId && !document.querySelector(`script[src*="${gaId}"]`)) {
      // GA4 needs both the loader and the inline init script.
      const loader = document.createElement('script');
      loader.async = true;
      loader.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(loader);

      const init = document.createElement('script');
      init.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${gaId}', { anonymize_ip: true });
      `;
      document.head.appendChild(init);
    }
  }, []);

  return null;
}

export default Analytics;
